import axios from 'axios';

// Sem tracking, sem cookies, sem analytics
const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor para garantir que não temos cookies de tracking
api.interceptors.request.use((config) => {
  // Remove qualquer header de rastreamento
  delete config.headers['X-Tracking-ID'];
  delete config.headers['X-Analytics'];
  return config;
});

// FastAPI manda `detail` como texto (HTTPException) ou como lista de erros
// de validação do Pydantic — nos dois casos vira uma frase única para exibir.
export function extrairErro(err, fallback) {
  const detail = err.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => d.msg).filter(Boolean).join(' ') || fallback;
  }
  return fallback;
}

export default api;
